/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SurveyssubmissionsSubmissionResponses model module.
 * @module model/SurveyssubmissionsSubmissionResponses
 * @version v0.3
 */
export default class SurveyssubmissionsSubmissionResponses {
  /**
   * Constructs a new <code>SurveyssubmissionsSubmissionResponses</code>.
   * @alias module:model/SurveyssubmissionsSubmissionResponses
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurveyssubmissionsSubmissionResponses</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurveyssubmissionsSubmissionResponses} obj Optional instance to populate.
   * @return {module:model/SurveyssubmissionsSubmissionResponses} The populated <code>SurveyssubmissionsSubmissionResponses</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurveyssubmissionsSubmissionResponses();
      if (data.hasOwnProperty('answer_id'))
        obj.answerId = ApiClient.convertToType(data['answer_id'], 'String');
      if (data.hasOwnProperty('content'))
        obj.content = ApiClient.convertToType(data['content'], 'String');
    }
    return obj;
  }
}

/**
 * If the question has pre-determined answer choices, the ID of the answer choice
 * @member {String} answerId
 */
SurveyssubmissionsSubmissionResponses.prototype.answerId = undefined;

/**
 * Content of the response. Use cases for this are:  - A text response if the answer_id corresponds to a response of 'Other'  - A text response if the question calls for free text  - A text response to one part of a MultiTextQuestion. See 'Questionnaires' for more details on this use case
 * @member {String} content
 */
SurveyssubmissionsSubmissionResponses.prototype.content = undefined;

